// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebarContainer {
    /* min-height: 30vh; */
    display: flex;
    height: 100%;
    float: right;
    background-color: var(--color-white);
    overflow: hidden;
    border-radius: 0 .75em .75em 0;
    width: 25px;
    transition: width .2s ease-out;
    color:#000;
}
#sidebarContainer.isOpen {
    width: 320px;
}

#sidebarLabel {
    cursor:pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size:0.9rem;
    font-weight: 600;
    padding-top: 10px;
    float: left;
    color: var(--color-white);
    position: relative;
    padding-top: 8px;
    background-color: var(--color-white);
    /* box-shadow: 2px 0px 0px var(--color-primary-green); */
    text-align: center;
}

.sidebar-collapse-icon {
    color: var(--color-primary-orange);
    font-size: 0.9rem;
}

.sidebar-filter-icon {
    color: var(--color-primary-orange);
    font-size: 0.9rem;
}

.sidebar-label-text {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    color: var(--color-primary-orange);
}

#sidebarFilters {
    /* margin-left: 30px; */
    min-width: 290px;
    max-height: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    padding: 10px;
    /* border:3px solid var(--color-primary-green); */
    border-radius:  0 0.75em 0.75em 0;
    display: flex;
    flex-direction: column;
}

.rowTitle {
    cursor: pointer;
    display: flex;
}
.rowTitle:hover{
    background-color: #00000030;
}

.rowTitleText::after {
    display: flex;
    font-family: "Font Awesome 6 Free";
    content: "\\f0d7";
    font-weight: 800;
    padding-right:10px;
    margin-left:auto;
}

.rowTitle.isOpen .rowTitleText::after {
    content: "\\f0d8";
}

.rowFilters {
    max-height: 0px;
    height: auto;
    overflow: hidden;
    transition: max-height .15s ease-out;
}
.rowFilters > div{
    overflow: visible !important;
}
.rowFilters > div > div{
    padding:5px;
    overflow: visible;
}
.rowFilters > div > div > *{
    /* margin-top:10px; */
    margin-bottom:10px;
}

.rowTitle.isOpen+.rowFilters {
    max-height: 500px;
    transition: max-height .15s ease-in;
    animation: .5s delay-overflow;
    overflow: visible;
}

.rowTitleText {
    display: flex;
    width: 230px;
    padding-left: .5rem;
}
.rowTitle.filtered {
    background-color: #0066ff30;
    font-weight: 600;
}

.radio-input:last-child{
    margin-left:20px;
}
#headerTitle{
    /*border-bottom: 1px solid #00000050;
    margin-bottom: 5px;*/
    margin-right: 3px;
    padding-bottom: 5px;
    font-size: 1.3rem;
    flex-shrink: 0;
}

.individualFilterContainer{
    flex: 1 1;
    min-height: 0;
    padding-right: 10px;
    margin-right: -10px;
    overflow-y: auto;
    overflow-x: visible;
    padding-bottom: 20px;
}
.checkboxContainer{
    float:left;
    padding-top:2px;
    padding-left:5px;
    height:13px;
}

.search-container{
   /* padding-left: 8px;
    padding-right:8px;*/
    padding-bottom:4px;
    flex-shrink: 0;
}
.search-input {
    border: 2px solid var(--color-primary-orange);
}
.rowFilters > div > div > div {
    padding-bottom:2px;
    padding-top:2px;
    margin-bottom: 2px;
}

.sidebar-value-input{
    display: flex;
}
.sidebar-value-input .x-icon-container{
    cursor: pointer;
    padding:2px 7px;
    margin-top:6px;
    margin-bottom:5px;
    /* margin-left: -28px; */
    background-color: rgb(226, 48, 48);
    color: var(--color-white);
}
.react-datepicker-wrapper{
    margin-right:2px;
}

@keyframes delay-overflow {
    from {
        overflow: hidden;
    }
}
@media (max-width: 768px) {
  #table-container {
    position: relative;
  }

  #sidebarContainer {
    position: absolute !important;
    top: 42px;   /* pushes below the Export/Clear Filters buttons */
    right: 0;
    height: calc(100% - 42px) !important;
    z-index: 1000;
    border-radius: 0.75em 0 0 0.75em;
  }

  #sidebarContainer.isOpen {
    width: 90% !important;
    max-width: 320px;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/listview/SidebarFilter/SideBarFilters.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,8BAA8B;IAC9B,UAAU;AACd;AACA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,wDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,iDAAiD;IACjD,iCAAiC;IACjC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI;wBACoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;GACG;uBACoB;IACnB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,kCAAkC;IAClC,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,SAAS,IAAI,kDAAkD;IAC/D,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF","sourcesContent":["#sidebarContainer {\n    /* min-height: 30vh; */\n    display: flex;\n    height: 100%;\n    float: right;\n    background-color: var(--color-white);\n    overflow: hidden;\n    border-radius: 0 .75em .75em 0;\n    width: 25px;\n    transition: width .2s ease-out;\n    color:#000;\n}\n#sidebarContainer.isOpen {\n    width: 320px;\n}\n\n#sidebarLabel {\n    cursor:pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    font-size:0.9rem;\n    font-weight: 600;\n    padding-top: 10px;\n    float: left;\n    color: var(--color-white);\n    position: relative;\n    padding-top: 8px;\n    background-color: var(--color-white);\n    /* box-shadow: 2px 0px 0px var(--color-primary-green); */\n    text-align: center;\n}\n\n.sidebar-collapse-icon {\n    color: var(--color-primary-orange);\n    font-size: 0.9rem;\n}\n\n.sidebar-filter-icon {\n    color: var(--color-primary-orange);\n    font-size: 0.9rem;\n}\n\n.sidebar-label-text {\n    writing-mode: vertical-rl;\n    text-orientation: mixed;\n    color: var(--color-primary-orange);\n}\n\n#sidebarFilters {\n    /* margin-left: 30px; */\n    min-width: 290px;\n    max-height: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    padding: 10px;\n    /* border:3px solid var(--color-primary-green); */\n    border-radius:  0 0.75em 0.75em 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.rowTitle {\n    cursor: pointer;\n    display: flex;\n}\n.rowTitle:hover{\n    background-color: #00000030;\n}\n\n.rowTitleText::after {\n    display: flex;\n    font-family: \"Font Awesome 6 Free\";\n    content: \"\\f0d7\";\n    font-weight: 800;\n    padding-right:10px;\n    margin-left:auto;\n}\n\n.rowTitle.isOpen .rowTitleText::after {\n    content: \"\\f0d8\";\n}\n\n.rowFilters {\n    max-height: 0px;\n    height: auto;\n    overflow: hidden;\n    transition: max-height .15s ease-out;\n}\n.rowFilters > div{\n    overflow: visible !important;\n}\n.rowFilters > div > div{\n    padding:5px;\n    overflow: visible;\n}\n.rowFilters > div > div > *{\n    /* margin-top:10px; */\n    margin-bottom:10px;\n}\n\n.rowTitle.isOpen+.rowFilters {\n    max-height: 500px;\n    transition: max-height .15s ease-in;\n    animation: .5s delay-overflow;\n    overflow: visible;\n}\n\n.rowTitleText {\n    display: flex;\n    width: 230px;\n    padding-left: .5rem;\n}\n.rowTitle.filtered {\n    background-color: #0066ff30;\n    font-weight: 600;\n}\n\n.radio-input:last-child{\n    margin-left:20px;\n}\n#headerTitle{\n    /*border-bottom: 1px solid #00000050;\n    margin-bottom: 5px;*/\n    margin-right: 3px;\n    padding-bottom: 5px;\n    font-size: 1.3rem;\n    flex-shrink: 0;\n}\n\n.individualFilterContainer{\n    flex: 1;\n    min-height: 0;\n    padding-right: 10px;\n    margin-right: -10px;\n    overflow-y: auto;\n    overflow-x: visible;\n    padding-bottom: 20px;\n}\n.checkboxContainer{\n    float:left;\n    padding-top:2px;\n    padding-left:5px;\n    height:13px;\n}\n\n.search-container{\n   /* padding-left: 8px;\n    padding-right:8px;*/\n    padding-bottom:4px;\n    flex-shrink: 0;\n}\n.search-input {\n    border: 2px solid var(--color-primary-orange);\n}\n.rowFilters > div > div > div {\n    padding-bottom:2px;\n    padding-top:2px;\n    margin-bottom: 2px;\n}\n\n.sidebar-value-input{\n    display: flex;\n}\n.sidebar-value-input .x-icon-container{\n    cursor: pointer;\n    padding:2px 7px;\n    margin-top:6px;\n    margin-bottom:5px;\n    /* margin-left: -28px; */\n    background-color: rgb(226, 48, 48);\n    color: var(--color-white);\n}\n.react-datepicker-wrapper{\n    margin-right:2px;\n}\n\n@keyframes delay-overflow {\n    from {\n        overflow: hidden;\n    }\n}\n@media (max-width: 768px) {\n  #table-container {\n    position: relative;\n  }\n\n  #sidebarContainer {\n    position: absolute !important;\n    top: 42px;   /* pushes below the Export/Clear Filters buttons */\n    right: 0;\n    height: calc(100% - 42px) !important;\n    z-index: 1000;\n    border-radius: 0.75em 0 0 0.75em;\n  }\n\n  #sidebarContainer.isOpen {\n    width: 90% !important;\n    max-width: 320px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
